{
  "UI Elements": "UI Elements",
  "Forms & Tables": "Forms & Tables",
  "Pages": "Pages",
  "Charts & Maps": "Charts & Maps",
  "Others": "Others",
  "Typography": "Typography",
  "Cards": "Cards",
  "Basic": "Basic",
  "Advance": "Advance",
  "Widgets": "Widgets",
  "Components": "Components",
  "Alert": "Alert",
  "Avatar": "Avatar",
  "Badge": "Badge",
  "Button": "Button",
  "Calendar": "Calendar",
  "Image": "Image",
  "Pagination": "Pagination",
  "Progress Circular": "Progress Circular",
  "Progress Linear": "Progress Linear",
  "Autocomplete": "Autocomplete",
  "Tooltip": "Tooltip",
  "Slider": "Slider",
  "Date Time Picker": "Date Time Picker",
  "Select": "Select",
  "Switch": "Switch",
  "Checkbox": "Checkbox",
  "Radio": "Radio",
  "Textarea": "Textarea",
  "Rating": "Rating",
  "File Input": "File Input",
  "Form Layout": "Form Layout",
  "Form Validation": "Form Validation",
  "Charts": "Charts",
  "Apex Chart": "Apex Chart",
  "Chartjs": "Chartjs",
  "Account Settings": "Account Settings",
  "User Profile": "User Profile",
  "FAQ": "FAQ",
  "Dialog Examples": "Dialog Examples",
  "Pricing": "Pricing",
  "List": "List",
  "Edit": "Edit",
  "Nav Levels": "Nav Levels",
  "Level 2.1": "Level 2.1",
  "Level 2.2": "Level 2.2",
  "Level 3.1": "Level 3.1",
  "Level 3.2": "Level 3.2",
  "Raise Support": "Raise Support",
  "Documentation": "Documentation",
  "Dashboards": "Dashboards",
  "Analytics": "Analytics",
  "Apps & Pages": "Apps & Pages",
  "Email": "Email",
  "Chat": "Chat",
  "Invoice": "Invoice",
  "Preview": "Preview",
  "Add": "Add",
  "User": "User",
  "View": "View",
  "Login v1": "Login v1",
  "Login v2": "Login v2",
  "Login": "Login",
  "Register v1": "Register v1",
  "Register v2": "Register v2",
  "Register": "Register",
  "Forget Password v1": "Forget Password v1",
  "Forget Password v2": "Forget Password v2",
  "Forgot Password v1": "Forgot Password v1",
  "Forgot Password v2": "Forgot Password v2",
  "Forgot Password": "Forgot Password",
  "Reset Password v1": "Reset Password v1",
  "Reset Password v2": "Reset Password v2",
  "Reset Password": "Reset Password",
  "Miscellaneous": "Miscellaneous",
  "Coming Soon": "Coming Soon",
  "Not Authorized": "Not Authorized",
  "Under Maintenance": "Under Maintenance",
  "Error": "Error",
  "Statistics": "Statistics",
  "Actions": "Actions",
  "Access Control": "Access Control",
  "User Interface": "User Interface",
  "CRM": "CRM",
  "eCommerce": "eCommerce",
  "Icons": "Icons",
  "Chip": "Chip",
  "Dialog": "Dialog",
  "Expansion Panel": "Expansion Panel",
  "Combobox": "Combobox",
  "Textfield": "Textfield",
  "Range Slider": "Range Slider",
  "Menu": "Menu",
  "Snackbar": "Snackbar",
  "Tabs": "Tabs",
  "Form Elements": "Form Elements",
  "Form Layouts": "Form Layouts",
  "Authentication": "Authentication",
  "Page Not Found - 404": "Page Not Found - 404",
  "Not Authorized - 401": "Not Authorized - 401",
  "Server Error - 500": "Server Error - 500",
  "2": "2",
  "Forms": "Forms",
  "Timeline": "Timeline",
  "Disabled Menu": "Disabled Menu",
  "Help Center": "Help Center",
  "Verify Email": "Verify Email",
  "Verify Email v1": "Verify Email v1",
  "Verify Email v2": "Verify Email v2",
  "Two Steps": "Two Steps",
  "Two Steps v1": "Two Steps v1",
  "Two Steps v2": "Two Steps v2",
  "Custom Input": "Custom Input",
  "Extensions": "Extensions",
  "Tour": "Tour",
  "Register Multi-Steps": "Register Multi-Steps",
  "Wizard Examples": "Wizard Examples",
  "Checkout": "Checkout",
  "Create Deal": "Create Deal",
  "Property Listing": "Property Listing",
  "Roles & Permissions": "Roles & Permissions",
  "Roles": "Roles",
  "Simple Table": "Simple Table",
  "Tables": "Tables",
  "Data Table": "Data Table",
  "Permissions": "Permissions",
  "Apps": "Apps",
  "Misc": "Misc",
  "Dashboard": "Dashboard",
  "Products": "Products",
  "Sales": "Sales",
  "Affiliates": "Partners",
  "Integrations": "Integrations",
  "Reports": "Reports",
  "FAQ/Help Centre": "FAQ/Help Centre",
  "Retailer Nav": "Retailer Nav",
  "Affiliate List": "Partner List",
  "Affiliate Requests": "Partner's Requests",
  "Company": "Company",
  "Affiliate Nav": "Affiliate Nav",
  "My Products": "My Products",
  "Product Directory": "Product Directory",
  "Campaigns": "Campaigns",
  "Retailers": "Partners",
  "My Retailers": "My Partners",
  "Retailer Navigation": "Retailer Navigation",
  "Users": "Users",
  "Affiliates Requests": "Partner's Requests",
  "Import Management": "Import Management",
  "Discount Management": "Discount Management",
  "Commissions": "Commissions",
  "Profile Settings": "Profile Settings",
  "Partner Directory": "Partner Directory",
  "Shipping": "Shipping",
  "Transactions": "Transactions",
  "Notifications": "Notifications",
  "Affiliate Navigation": "Affiliate Navigation",
  "Users List": "Users List",
  "Activity Log": "Activity Log",
  "Import List": "Import List",
  "Import Configuration": "Import Configuration",
  "Login Restriction": "Login Restriction",
  "Settlements": "Settlements",
  "Orders": "Orders",
  "Commission": "Commissions",
  "Profile and Checkout": "Profile and Checkout",
  "IP Access Management": "IP Access Management",
  "Imports": "Imports",
  "Settings": "Settings",
  "My Affiliates": "My Partners",
  "My Campaigns": "My Campaigns",
  "My Links": "My Links",
  "Profile": "Profile",
  "Partner Requests": "Partner Requests",
  "Commission Rules": "Commission Rules",
  "Product Sets": "Product Sets",
  "Product Sales": "Product Sales",
  "Partner Sales": "Partner Sales",
  "Storefronts": "Storefronts",
  "Galleries": "Galleries",
  "Showcase Pages": "Showcase Pages",
  "Links": "Links",
  "Landing Pages": "Landing Pages",
  "Campaigns & Links": "Campaigns & Links",
  "Discounts": "Discounts",
  "Tools": "Tools",
  "GBP": "£",
  "USD": "$",
  "3": "3",
  "$vuetify": {
    "badge": "Badge",
    "pagination": {
      "ariaLabel": {
        "root": "root",
        "previous": "previous",
        "next": "next",
        "currentPage": "currentPage",
        "page": "page"
      }
    },
    "input": {
      "clear": "clear",
      "appendAction": "appendAction",
      "prependAction": "prependAction",
      "counterSize": "counterSize"
    },
    "fileInput": {
      "counterSize": "counterSize"
    },
    "rating": {
      "ariaLabel": {
        "item": "item"
      }
    }
  }
}
